<script>

	import { createEventDispatcher } from 'svelte';

	import Menu from "./Menu.svelte";
	import Dialog from "./Dialog.svelte";
	import Overlay from "./Overlay.svelte";
	import Field from './Field.svelte';
	import Button from './Button.svelte';
	// import MakeReport from './Reports/MakeReport.svelte';
	// import Eject from './Reports/Eject.svelte';

	import { postServerData } from '../lib/prelude.js';
	import {	event, bigError, shadowbans, attendee as atnd } from '../lib/stores.js';

	const dispatch = createEventDispatcher();

	export let attendee;
	export let profile = null;
	export let menuOpen = false;

	let menuOptions = [];
	let menuWidth = '10rem';

	let shadowbanDialog = null;

	// 22 Jul 2024 -- does ejecting make sense in the context of the app?
	// -- cf Report.svelte
	// let allowEject = false;
	// let ejectOverlay = false;
	// let ejectMessage = '';
	// let ejectDialog = null;

	let reportOverlay = false;

	function setMenuOptions() {

		menuOptions = [];

		if ($atnd.ref != attendee.ref) {
			menuOptions.push({
				value: 'report',
				label: 'Report',
				icon: '<svg viewBox="0 0 20 20"><path d="M4.96 16.95l-1.17-13.39c-.02-.14.09-.26.22-.27l.5-.04c.14-.01.26.09.27.23l1.17 13.48h-.99zM8.11 4.05c.74 0 1.53.14 2.28.3.82.17 1.77.34 2.67.34l.57-.02c.26-.02.53-.05.8-.11.14-.03.28.08.29.22l.44 5.07c.01.12-.07.23-.18.26-.21.06-.48.11-.87.14l-.4.02c-.72 0-1.55-.15-2.27-.3-.84-.17-1.75-.34-2.67-.34-.21 0-.42.01-.61.03-.35.03-.64.09-.9.16l-.48-5.52c.22-.12.48-.2.88-.24l.45-.01m0-1l-.53.02c-.99.09-1.41.43-1.85.7l.66 7.59c.44-.27.86-.61 1.85-.7.17-.02.35-.02.53-.02.87 0 1.75.16 2.48.32.91.19 1.72.32 2.47.32l.48-.02c.89-.08 1.47-.24 1.94-.65.06-.05.09-.13.08-.21l-.61-7c-.01-.14-.13-.23-.25-.23l-.14.04c-.42.27-.95.39-1.68.45l-.48.02c-.75 0-1.56-.13-2.47-.32-.74-.15-1.61-.31-2.48-.31z"/></svg>'
			});
		}

		if (($atnd.type == 'login') && ($atnd.permissions.includes('virtual-eject'))) {

			menuOptions.push({
				value: 'shadowban',
				label: (profile && profile.shadowban) ? 'Cancel shadow ban' : 'Shadow ban',
				icon: (profile && profile.shadowban) ? '<svg viewBox="0 0 20 20"><ellipse cx="11.29" cy="8.32" rx=".71" ry="1.22"/><path d="M15.12 16.83c.1.12.24.18.38.18.11 0 .23-.04.32-.12.21-.18.24-.49.06-.7l-.61-.73c.12.02.23.03.35.02.21-.03.4-.14.52-.33.28-.42.14-1.07.06-1.33-.08-.28-.34-.99-.6-1.7l-.3-.83c-.23-.6-.34-.9-.42-1.62-.11-1-.43-2.43-.97-3.47-.82-1.56-2.15-2.38-3.86-2.38-1.35 0-2.46.51-3.28 1.5l-1.79-2.13c-.18-.21-.49-.24-.7-.06-.22.17-.24.49-.07.7l10.91 13zm-5.56-8.18l.04-.33c0-.67-.32-1.22-.71-1.22-.16 0-.3.11-.41.26l-1.05-1.25c.63-.85 1.51-1.28 2.61-1.28 1.33 0 2.33.62 2.97 1.84.48.91.76 2.25.86 3.12.1.85.25 1.26.49 1.88l.3.81.45 1.24c.25.67-.15.44-.29.36-.18-.09-.42-.21-.75-.21l-.11.02-4.4-5.24zM12.06 15.18c-.19 0-.39-.15-.58-.3-.3-.23-.73-.55-1.43-.55s-1.13.31-1.43.55c-.19.15-.39.3-.58.3-.17 0-.24 0-.62-.45-.34-.41-.73-.85-1.38-.86-.33-.01-.57.12-.75.21-.14.08-.54.31-.29-.36l.45-1.24.3-.81c.24-.62.39-1.03.49-1.88.05-.46.16-1.05.31-1.63l-.79-.93c-.29.83-.47 1.74-.55 2.44-.08.72-.2 1.02-.42 1.62l-.31.82c-.26.71-.52 1.42-.6 1.7-.07.26-.21.91.06 1.33.12.18.3.3.52.33.44.06.88-.2 1.18-.42.15-.11.29-.17.4-.17.13 0 .26.11.59.5.39.46.74.81 1.4.81.55 0 .95-.31 1.27-.57.23-.18.45-.28.74-.28.3 0 .5.1.74.28.32.25.72.57 1.27.57.4 0 .69-.14.94-.34l-.64-.76c-.12.08-.2.09-.29.09z"/></svg>' : '<svg viewBox="0 0 20 20"><ellipse cx="8.89" cy="8.32" rx=".71" ry="1.22"/><ellipse cx="11.29" cy="8.32" rx=".71" ry="1.22"/><path d="M10.04 15.33c-.29 0-.5.1-.74.28-.32.25-.72.57-1.27.57-.67 0-1.02-.35-1.4-.81-.33-.39-.46-.5-.59-.5-.1 0-.25.07-.4.17-.3.22-.74.47-1.18.42-.21-.03-.4-.14-.52-.33-.28-.42-.14-1.07-.06-1.33.08-.28.34-.99.6-1.7l.31-.82c.23-.6.34-.9.42-1.62.11-1 .43-2.43.97-3.47.82-1.55 2.15-2.37 3.86-2.37s3.04.82 3.86 2.38c.54 1.03.86 2.47.97 3.47.08.72.2 1.02.42 1.62l.31.82c.26.71.52 1.42.6 1.7.07.26.21.91-.06 1.33-.12.18-.3.3-.52.33-.44.06-.88-.2-1.18-.42-.15-.11-.29-.17-.4-.17-.13 0-.26.11-.59.5-.39.46-.74.81-1.4.81-.55 0-.95-.31-1.27-.57-.24-.19-.44-.29-.74-.29zm0-1c.7 0 1.13.31 1.43.55.19.15.39.3.58.3.17 0 .24 0 .62-.45.34-.41.73-.85 1.38-.86.33-.01.57.12.75.21.14.08.54.31.29-.36l-.45-1.24-.3-.81c-.24-.62-.39-1.03-.49-1.88-.1-.87-.38-2.21-.86-3.12-.62-1.23-1.62-1.85-2.95-1.85s-2.32.62-2.97 1.84c-.47.91-.76 2.25-.86 3.12-.1.85-.25 1.26-.49 1.88l-.3.81-.45 1.24c-.25.67.15.44.29.36.18-.09.42-.21.75-.21.65.01 1.04.46 1.38.86.38.45.45.45.62.45.19 0 .39-.15.58-.3.32-.23.76-.54 1.45-.54z"/></svg>'
			});

			menuWidth = (profile && (profile.shadowban || profile.ejected)) ? '14rem' : '11rem';

		}

	}

	function menuAction(e) {

		const action = e.detail.value;

		if (action == "removeFromContacts") {
			dispatch('remove');
		}

		dispatch('escape');

		if (action == "mute") {
			toggleMute();
		} else if (action == "report") {
			reportOverlay = true;
		} else if (action == "shadowban") {
			if (profile && profile.shadowban) {
				shadowbanDialog = {
					text: "Are you sure you want to remove the shadow ban on this attendee?",
					info: [
						"All content they have posted will become visible again to other attendees."
					],
					actions: [
						{
							label: "Confirm",
							dispatch: "confirm"
						},
						{
							label: "Cancel",
							ghost: true,
							dispatch: "escape"
						}
					]
				};
			} else {
				shadowbanDialog = {
					text: "Are you sure you want to shadow ban this attendee?",
					info: [
						"No content they post will be visible to other attendees.",
						"The attendee will be unaware of this."
					],
					actions: [
						{
							label: "Confirm",
							dispatch: "confirm"
						},
						{
							label: "Cancel",
							ghost: true,
							dispatch: "escape"
						}
					]
				};
			}
		}
	}

	async function toggleShadowban() {

		shadowbanDialog = null;

		await postServerData('onstage/shadowban', {
			attendee: attendee.ref
		});

		if (profile && !$bigError) {
			profile.shadowban = !profile.shadowban;
		}

	}

	$: if (profile) {
		setMenuOptions();
	}

</script>

<style>
	.menuWrap {
		display: contents;
	}
	.menuWrap :global(.menu) {
		width: var(--menuWidth);
	}
</style>

{#if menuOpen && menuOptions.length}
	<div class="menuWrap" style="--menuWidth:{menuWidth}">
		<Menu
			options={menuOptions}
			on:selected={(e) => { menuAction(e) }}
			on:escape
			arrow={true}
		/>
	</div>
{/if}

{#if shadowbanDialog}
	<Dialog
		{...shadowbanDialog}
		on:escape={() => { shadowbanDialog = null}}
		on:confirm={toggleShadowban}
	/>
{/if}

<!-- {#if reportOverlay}
	<Overlay on:escape={() => { reportOverlay = false }}>
		<MakeReport attendee={attendee.ref} on:escape={() => { reportOverlay = false }}/>
	</Overlay>
{/if} -->
